/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Timeout.ts
 */

import APIError from "./APIError";

export default class Timeout extends APIError {
    constructor(message: string) {
        super("Délai expiré", 408, message);
    }
}